"use strict";

/**
 * @classdesc
 * Entfernt alle Layer des Layertree.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action.layer
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} options.map Referenz auf die Karte
 */
gc.gis.action.layer.RemoveAllLayer = function(options)
{
	gc.gis.action.GCAbstractAction.call(this);

	/**
	 * @inheritdoc
	 */
	this.func = this.doExecute;
	/**
	 * @inheritdoc
	 */
	this.args = [options.map];
};
gc.gis.action.layer.RemoveAllLayer.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);

/**
 * Entfernt alle Layer des Layertree.
 * <em>Hinweis: Diese Funktion sollte nicht manuell aufgerufen werden.</em>
 *
 * @public
 * @param {gc.gis.map.GCMapView} map Referenz auf die Karte
 * @see gc.gis.action.GCAbstractAction#execute
 */
gc.gis.action.layer.RemoveAllLayer.prototype.doExecute = function(map)
{
	map.removeAllLayers();
};